"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductPresentations = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const attributes_1 = require("../../client/attributes");
const get_product_presentation_short_query_1 = require("../../client/product/get-product-presentation-short.query");
const product_tree_nodes_1 = require("../../client/product-tree-nodes");
const useProductPresentations = (productTreeId, catalogId) => {
    const [selectedCategory, setSelectedCategory] = (0, react_1.useState)(null);
    const [productPresentationsState, setProductPresentationsState] = (0, react_1.useState)({
        data: {
            selectedCategoryData: null,
            uncategorizedData: null,
        },
        loading: false,
        error: null,
    });
    const { data: terminalNodes, isLoading: productTreeNodesLoading, error: productTreeNodesError, } = (0, product_tree_nodes_1.useProductTreeNodes)({
        productTreeId,
        filter: { terminalNodesOnly: true },
        options: { skip: !productTreeId },
    });
    const uncategorizedItemId = (0, react_1.useMemo)(() => { var _a; return (((_a = terminalNodes === null || terminalNodes === void 0 ? void 0 : terminalNodes.find((item) => item.title === attributes_1.UN_CATEGORIZED_NODE_TITLE)) === null || _a === void 0 ? void 0 : _a.id) || null); }, [terminalNodes]);
    const [fetchProductPresentations, { data, loading, error }] = (0, react_2.useLazyQuery)(get_product_presentation_short_query_1.GET_PRODUCT_TREE_NODES_PRODUCT_PRESENTATIONS_SHORT, {
        fetchPolicy: 'cache-first',
        notifyOnNetworkStatusChange: true,
    });
    (0, react_1.useEffect)(() => {
        if (selectedCategory === uncategorizedItemId)
            return;
        const filterProductTreeNode = [];
        if (uncategorizedItemId) {
            filterProductTreeNode.push(uncategorizedItemId);
        }
        if (selectedCategory) {
            filterProductTreeNode.push(selectedCategory);
        }
        if (filterProductTreeNode.length > 0) {
            void fetchProductPresentations({
                variables: {
                    ancestralProductTreeId: productTreeId,
                    catalog: catalogId,
                    filter: {
                        id: {
                            in: filterProductTreeNode,
                        },
                    },
                },
            });
        }
    }, [selectedCategory, uncategorizedItemId, catalogId, fetchProductPresentations, productTreeId]);
    const handleFetchPresentationsStateChange = (0, react_1.useCallback)(() => {
        if (!data || !data.productTreeNodes || !data.productTreeNodes.edges) {
            setProductPresentationsState({
                data: {
                    selectedCategoryData: null,
                    uncategorizedData: null,
                },
                loading,
                error,
            });
            return;
        }
        const { edges } = data.productTreeNodes;
        let selectedCategoryData = null;
        let uncategorizedData = null;
        if (edges.length > 1) {
            uncategorizedData = edges.find((edge) => edge.node.title === attributes_1.UN_CATEGORIZED_NODE_TITLE) || null;
            selectedCategoryData = edges.find((edge) => edge.node.id !== (uncategorizedData === null || uncategorizedData === void 0 ? void 0 : uncategorizedData.node.id)) || null;
        }
        else if (edges.length === 1) {
            [uncategorizedData] = edges;
        }
        setProductPresentationsState({
            data: {
                selectedCategoryData,
                uncategorizedData,
            },
            loading,
            error,
        });
    }, [data, loading, error]);
    (0, react_1.useEffect)(() => {
        handleFetchPresentationsStateChange();
    }, [data, loading, error, handleFetchPresentationsStateChange]);
    return {
        selectedCategory,
        setSelectedCategory,
        productPresentationsState,
        terminalNodes,
        productTreeNodesLoading,
        productTreeNodesError,
    };
};
exports.useProductPresentations = useProductPresentations;
